/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import TagManager from 'react-gtm-module';
import $ from 'jquery';
import MetaTags from 'react-meta-tags';

function CommoditySpeaker() {
	let location = useLocation();
	const tagManagerArgs = {
		gtmId: 'GTM-NDBLPCX'
	}
	TagManager.initialize(tagManagerArgs);
	useEffect(() => {
		// popup window
		$(".btn_popup").on('click', function () {
			$(".popup").hide();
			var href = "#" + $(this).attr('id');
			$(href).show();
		})
		$(".btn_close").on('click', function () {
			$(".popup").hide();
		});

		// mini switch
		$(function () {
			var $li = $('ul.tab-title li');
			$($li.eq(0).addClass('active').find('a').attr('href')).siblings('.tab-inner').hide();

			$li.click(function () {
				$($(this).find('a').attr('href')).show().siblings('.tab-inner').hide();
				$(this).addClass('active').siblings('.active').removeClass('active');
			});
		});
	}, [location])
	return (
		<>
			<MetaTags>
				<title>中華電信i寶貝智慧音箱-商品專區</title>
				<meta name="keywords" content="i寶貝商品專區, Lucia,Mini,智慧音選,優惠方案,0元方案,i寶貝免費帶回家,聲控服務,購買聲控內容"></meta>
				<meta name="description" content="i寶貝智慧音箱的款式介紹，目前僅有入門款的Lucia Mini智慧音箱，但有莫蘭迪綠及白色可選擇。同時也可比較智慧音箱與手機門號、固網搭配的優惠方案，找出最符合您需的購買智慧音箱方案。另外，也可申購i寶貝智慧聲控服務的聲音內容 ，例 ：kkbox、愛播聽書、i聽聽…等，五花八門的內容任您挑選。" />
				<meta property="og:title" content="中華電信i寶貝智慧音箱-商品專區" />
				<meta property="og:Description" content="i寶貝智慧音箱的款式介紹，目前僅有入門款的Lucia Mini智慧音箱，但有莫蘭迪綠及白色可選擇。同時也可比較智慧音箱與手機門號、固網搭配的優惠方案，找出最符合您需的購買智慧音箱方案。另外，也可申購i寶貝智慧聲控服務的聲音內容 ，例 ：kkbox、愛播聽書、i聽聽…等，五花八門的內容任您挑選。" />
				<meta property="og:image" content="https://ibobby.ai.hinet.net/app_icons/app_banner/imgUpload_496bf11d-5c35-41c7-b18c-894e7331f961.png" />
			</MetaTags>
			<div className="popup" id="cb_pop01">
				<div className="pagesize">
					<div className="popup_box pb_big commodity_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cob_box flex_set">
								<div className="cob_img flex_box"><img src={require("../../image/img_ibobby02.jpg").default} alt="img_ibobby02" /></div>
								<div className="cob_txt flex_box">
									<h4>【入門款】LUCIA Mini</h4>
									<h5>建議售價：2,490 元</h5>
									<ul className="list_sty">
										<li>外觀尺寸：114 x 114 x 45.4mm</li>
										<li>無線傳輸：802.11 b/g/n，2.4GHz WiFi</li>
										<li>藍芽：Bluetooth 4.2</li>
										<li>揚聲器輸出功率：5W</li>
										<li>電源規格：110V~220V</li>
										<li>保固期：1年</li>
										<li>喚醒詞：i寶貝</li>
										<li>語音輸入提示音：叮</li>
									</ul>
									<div className="btn_main flex_set">
										<a href={require("../../pdf/Luciamini_Guide.pdf").default} target="_blank" className="flex_box" rel="noreferrer">使用手冊</a>
										<Link as={Link} to={"/container/commodity/CommodityPlan"} >優惠方案</Link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop02">
				<div className="pagesize">
					<div className="popup_box pb_big commodity_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cob_box flex_set">
								<div className="cob_img flex_box"><img src={require("../../image/img_ibobby05.png").default} alt="img_ibobby05" /></div>
								<div className="cob_txt flex_box">
									<h4>【入門款】LUCIA Mini</h4>
									<h5>建議售價：2,490 元</h5>
									<ul className="list_sty">
										<li>外觀尺寸：114 x 114 x 45.4mm</li>
										<li>無線傳輸：802.11 b/g/n，2.4GHz WiFi</li>
										<li>藍芽：Bluetooth 4.2</li>
										<li>揚聲器輸出功率：5W</li>
										<li>電源規格：110V~220V</li>
										<li>保固期：1年</li>
										<li>喚醒詞：i寶貝</li>
										<li>語音輸入提示音：叮</li>
									</ul>
									<div className="btn_main flex_set">
										<a href={require("../../pdf/Luciamini_Guide.pdf").default} target="_blank" className="flex_box" rel="noreferrer">使用手冊</a>
										<Link as={Link} to={"/container/commodity/CommodityPlan"} >優惠方案</Link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop03">
				<div className="pagesize">
					<div className="popup_box pb_big commodity_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cob_box flex_set">
								<div className="cob_img flex_box"><img src={require("../../image/img_ibobby03.jpg").default} alt="img_ibobby03" /></div>
								<div className="cob_txt flex_box">
									<h4>【高階款】MS2806</h4>
									<h5>建議售價：5,990 元</h5>
									<ul className="list_sty">
										<li>外觀尺寸：直徑114mm；高224mm</li>
										<li>無線傳輸：802.11 b/g/n，2.4GHz WiFi</li>
										<li>藍芽：Bluetooth 4.0</li>
										<li>揚聲器輸出功率：15W</li>
										<li>電源規格：100V~240V</li>
										<li>保固期：1年</li>
										<li>喚醒詞：i寶貝</li>
										<li>語音輸入提示音：請說</li>
									</ul>
									<div className="btn_main flex_set">
										<a href={require("../../pdf/CHT_MS2806_QSG_20190409.pdf").default} target="_blank" className="flex_box" rel="noreferrer">使用手冊</a>
										<a href="#" className="flex_box btn_none">商品完售</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop04">
				<div className="pagesize">
					<div className="popup_box pb_big commodity_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cob_box flex_set">
								<div className="cob_img flex_box"><img src={require("../../image/img_ibobby04.jpg").default} alt="img_ibobby04" /></div>
								<div className="cob_txt flex_box">
									<h4>【高階款】LUCIA</h4>
									<h5>建議售價：7,990 元</h5>
									<ul className="list_sty">
										<li>外觀尺寸：308.6 x 135.3 x 97.2mm</li>
										<li>無線傳輸：802.11b/g/n/ac，2.4 GHz/5GHz</li>
										<li>藍芽：Bluetooth 4.2 /BLE</li>
										<li>電源規格: 12V/2.5A</li>
										<li>保固期：1年</li>
										<li>喚醒詞：i寶貝</li>
										<li>語音輸入提示音：叮</li>
										<li>備註：需同時下載i寶貝App &amp; bIOS LUCIA App以體驗附加功能。</li>
									</ul>
									<div className="btn_main flex_set">
										<a href={require("../../pdf/Lucia_Guide.pdf").default} target="_blank" className="flex_box" rel="noreferrer">使用手冊</a>
										<a href="#" className="flex_box btn_none">商品完售</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="content_inpage">
				<div className="pagesize">

					<ul className="bread">
						<li><a href="/">首頁</a></li>
						<li><a href="/container/commodity">商品專區</a></li>
					</ul>
					<div className="tab_con">
						<div className="tab_box active">

							<h2 className="tit_main">商品專區-音箱專區</h2>

							<div className="content_box commodity_box">
								<div className="table_box show_web">
									<table border="0" cellPadding="0" cellSpacing="0">
										<tbody>
											<tr>
												<th width="10%">項目</th>
												<th width="30%">[入門款] LUCIA Mini</th>
												<th width="30%">[高階款] MS2806</th>
												<th width="30%">[高階款] LUCIA</th>
											</tr>
											<tr>
												<th className="sty01">商品資訊</th>
												<td>
													<div id="tab-demo">
														<div className="cob_box flex_box" style={{ "position": "relative", "top": "18px" }}>
															<div id="tab01" className="tab-inner">
																<div className="cob_img"><img src={require("../../image/img_ibobby02.jpg").default} alt="img_ibobby02" /></div>
																<div className="cob_btn">
																	<a id="cb_pop01" className="btn_popup">商品詳情</a>
																	<Link as={Link} to={"/container/commodity/CommodityPlan"}>優惠方案</Link>
																</div>
															</div>
															<div id="tab02" className="tab-inner">
																<div className="cob_img"><img src={require("../../image/img_ibobby05.png").default} alt="img_ibobby05" /></div>
																<div className="cob_btn">
																	<a id="cb_pop02" className="btn_popup">商品詳情</a>
																	<Link as={Link} to={"/container/commodity/CommodityPlan"}>優惠方案</Link>
																</div>
															</div>
														</div>
														<ul className="tab-title">
															<li className="white"><a href="#tab01">tab1</a></li>
															<li className="green"><a href="#tab02">tab2</a></li>
														</ul>
													</div>
												</td>
												<td>
													<div className="cob_box flex_box">
														<div className="cob_img"><img src={require("../../image/img_ibobby03.jpg").default} alt="img_ibobby03" /></div>
														<div className="cob_btn"><a id="cb_pop03" className="btn_popup">商品詳情</a><a className="btn_none">商品完售</a></div>
													</div>
												</td>
												<td>
													<div className="cob_box flex_box">
														<div className="cob_img"><img src={require("../../image/img_ibobby04.jpg").default} alt="img_ibobby04" /></div>
														<div className="cob_btn"><a id="cb_pop04" className="btn_popup">商品詳情</a><a className="btn_none">商品完售</a></div>
													</div>
												</td>
											</tr>
											<tr>
												<th className="sty01">建議售價</th>
												<td>$ 2,490</td>
												<td>$ 5,990</td>
												<td>$ 7,990</td>
											</tr>
											<tr>
												<th className="sty01">尺寸(mm)</th>
												<td>114 X 114 X 45.4</td>
												<td>114 X 114 X 224</td>
												<td>308.6 X 135.3 X 97.2</td>
											</tr>
											<tr>
												<th className="sty01">硬體特色</th>
												<td className="txt_justify txt_middle">
													● 360度環繞收音<br />
													● 三米遠距聲音識別<br />
													● 藍牙綁定功能
												</td>
												<td className="txt_justify txt_middle">
													● 360度雙麥克風收音<br />
													● 全音域渾厚音場
												</td>
												<td className="txt_justify txt_middle">
													● 雙麥克風陣列<br />
													● 三米遠距聲音識別<br />
													● DPS音效增強技術<br />
													● 手機智能充電座<br />
													● 獨家「視覺化語音互動介面」可自動喚醒手機螢幕<br />
													● 智慧情境呼吸燈
												</td>
											</tr>
											<tr>
												<th className="sty01">可否外接行動電源</th>
												<td>O</td>
												<td>X</td>
												<td>X</td>
											</tr>
											<tr>
												<th className="sty01">適合族群</th>
												<td className="txt_justify txt_middle">
													● 適合擺放家庭，提供全家娛樂。<br />
													● 適合外出攜帶戶外活動<br />&emsp;(EX.露營、釣魚..)。
												</td>
												<td className="txt_justify txt_middle">
													● 適合擺放於辦公空間使用。
												</td>
												<td className="txt_justify txt_middle">
													● 適合擺放家庭，提供全家娛樂。
												</td>
											</tr>
										</tbody>
									</table>
								</div>

								<div className="table_box show_mobile">
									<table border="0" cellPadding="0" cellSpacing="0">
										<tbody>
											<tr>
												<th width="30%">項目</th>
												<th width="70%">[入門款] LUCIA Mini</th>
											</tr>
											<tr>
												<th className="sty01">商品資訊</th>
												<td>
													<div id="tab-demo">
														<div className="cob_box flex_box">
															<div id="tab03" className="tab-inner">
																<div className="cob_img"><img src={require("../../image/img_ibobby02.jpg").default} alt="img_ibobby02" /></div>
																<div className="cob_btn">
																	<a id="cb_pop01" className="btn_popup">商品詳情</a>
																	<Link as={Link} to={"/container/commodity/CommodityPlan"}>優惠方案</Link>
																</div>
															</div>
															<div id="tab04" className="tab-inner" style={{ "display": "none" }}>
																<div className="cob_img"><img src={require("../../image/img_ibobby05.png").default} alt="img_ibobby05" /></div>
																<div className="cob_btn">
																	<a id="cb_pop02" className="btn_popup">商品詳情</a>
																	<Link as={Link} to={"/container/commodity/CommodityPlan"}>優惠方案</Link>
																</div>
															</div>
														</div>
														<ul className="tab-title">
															<li className="white"><a href="#tab03">tab1</a></li>
															<li className="green"><a href="#tab04">tab2</a></li>
														</ul>
													</div>
												</td>
											</tr>
											<tr>
												<th className="sty01">建議售價</th>
												<td>$ 2,490</td>
											</tr>
											<tr>
												<th className="sty01">尺寸(mm)</th>
												<td>114 X 114 X 45.4</td>
											</tr>
											<tr>
												<th className="sty01">硬體特色</th>
												<td className="txt_justify">
													● 360度環繞收音<br />
													● 三米遠距聲音識別<br />
													● 藍牙綁定功能
												</td>
											</tr>
											<tr>
												<th className="sty01">可否外接行動電源</th>
												<td>O</td>
											</tr>
											<tr>
												<th className="sty01">適合族群</th>
												<td className="txt_justify">
													● 適合擺放家庭，提供全家娛樂。<br />
													● 適合外出攜帶戶外活動<br />&emsp;(EX.露營、釣魚..)。
												</td>
											</tr>
										</tbody>
									</table>
									<table border="0" cellPadding="0" cellSpacing="0">
										<tbody>
											<tr>
												<th width="30%">項目</th>
												<th width="70%">[高階款] MS2806</th>
											</tr>
											<tr>
												<th className="sty01">商品資訊</th>
												<td>
													<div className="cob_box flex_box">
														<div className="cob_img"><img src={require("../../image/img_ibobby03.jpg").default} alt="img_ibobby03" /></div>
														<div className="cob_btn"><a id="cb_pop03" className="btn_popup">商品詳情</a><a className="btn_none">商品完售</a></div>
													</div>
												</td>
											</tr>
											<tr>
												<th className="sty01">建議售價</th>
												<td>$ 5,990</td>
											</tr>
											<tr>
												<th className="sty01">尺寸(mm)</th>
												<td>114 X 114 X 224</td>
											</tr>
											<tr>
												<th className="sty01">硬體特色</th>
												<td className="txt_justify">
													● 360度雙麥克風收音<br />
													● 全音域渾厚音場
												</td>
											</tr>
											<tr>
												<th className="sty01">可否外接行動電源</th>
												<td>X</td>
											</tr>
											<tr>
												<th className="sty01">適合族群</th>
												<td className="txt_justify">
													● 適合擺放於辦公空間使用。
												</td>
											</tr>
										</tbody>
									</table>
									<table border="0" cellPadding="0" cellSpacing="0">
										<tbody>
											<tr>
												<th width="30%">項目</th>
												<th width="70%">[高階款] LUCIA</th>
											</tr>
											<tr>
												<th className="sty01">商品資訊</th>
												<td>
													<div className="cob_box flex_box">
														<div className="cob_img"><img src={require("../../image/img_ibobby04.jpg").default} alt="img_ibobby04" /></div>
														<div className="cob_btn"><a id="cb_pop04" className="btn_popup">商品詳情</a><a className="btn_none">商品完售</a></div>
													</div>
												</td>
											</tr>
											<tr>
												<th className="sty01">建議售價</th>
												<td>$ 7,990</td>
											</tr>
											<tr>
												<th className="sty01">尺寸(mm)</th>
												<td>308.6 X 135.3 X 97.2</td>
											</tr>
											<tr>
												<th className="sty01">硬體特色</th>
												<td className="txt_justify">
													● 雙麥克風陣列<br />
													● 三米遠距聲音識別<br />
													● DPS音效增強技術<br />
													● 手機智能充電座<br />
													● 獨家「視覺化語音互動介面」可自動喚醒手機螢幕<br />
													● 智慧情境呼吸燈
												</td>
											</tr>
											<tr>
												<th className="sty01">可否外接行動電源</th>
												<td>X</td>
											</tr>
											<tr>
												<th className="sty01">適合族群</th>
												<td className="txt_justify">
													● 適合擺放家庭，提供全家娛樂。
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default CommoditySpeaker;